import api from "./interceptor";
import axios from "axios";

export const signIn = (formData: { username: string; password: string; rememberMe: boolean }) => {
  let postData = {
    userName: formData.username,
    password: formData.password,
  };

  return api.post("/login", postData);
};

export const registeration = (formData: {
  companyName: string;
  companyAddress: string;
  contactName: string;
  companyContact: string;
  email: string;
  sendersName: string;
  username: string;
  password: string;
  confirmPassword: string;
  nic: string;
  vatNo: string;
  file: Array<File>;
  termsAndConditions: boolean;
}) => {
  let postData = new FormData();
  postData.append("userName", formData.username);
  postData.append("password", formData.password);
  postData.append("companyName", formData.companyName);
  postData.append("companyAddress", formData.companyAddress);
  postData.append("contact", "94" + formData.companyContact);
  postData.append("primaryContactName", formData.contactName);
  postData.append("BrcOrNic", formData.nic);
  postData.append("email", formData.email);
  postData.append("vatNumber", formData.vatNo);
  postData.append("file", formData.file[0]);
  postData.append("smsSendersName", formData.sendersName);

  return api.post("/self-registered-users-management/create-new-user", postData);
};

export const downloadFile = (url: string) => {
  return axios.get(url, {
    responseType: "blob",
  });
};

// endpoint manu list :-

// 01 channel service
// 02 rate card service
// 03 user service
// 04 report service
// 05 dashboard service
// 06 configaration service
// 07 mask service
// 07 campaign service

// -------------------# 01 channel services endpoints start here #-------------------------

export const getChannelList = (formData: object, page: number, rowsPerPage: number) => {
  let params = {
    page: page,
    size: rowsPerPage,
  };

  return api.post("/channel-management/get-all-channels", formData, {
    params: params,
  });
};

export const createChannel = (formData: object) => {
  return api.post("/channel-management/create-new-channel", formData);
};

export const updateChannel = (formData: object) => {
  return api.post("/channel-management/update-channel-details", formData);
};

export const getChannelListWithoutPagination = () => {
  return api.post("/channel-management/get-all-channels-without-pagination");
};

export const getRateCardChannelList = (values: object) => {
  return api.post("/channel-management/get-channels-without-pagination-by-rate-card-id", values);
};

export const getChannelDetailsById = (values: object) => {
  return api.post("/channel-management/get-assign-channel-details-by-cahnnel-id", values);
};

// -------------------# 02 rate card services endpoints start here #-------------------------

export const getRateCardList = (formData: object, page: number, rowsPerPage: number) => {
  let params = {
    page: page,
    size: rowsPerPage,
  };

  return api.post("/rate-card-management/get-all-rate-card-details", formData, {
    params: params,
  });
};

export const createRateCard = (formData: object) => {
  return api.post("/rate-card-management/create-new-rate-card", formData);
};

export const updateRateCard = (formData: object) => {
  return api.post("/rate-card-management/update-rate-card-details", formData);
};

export const getRateCardDetilsById = (formData: object) => {
  return api.post("/rate-card-management/get-rate-card-details-by-id", formData);
};

export const getRateCardListWithoutPagination = () => {
  return api.post("/rate-card-management/get-all-rate-card-details-without-pagination");
};

// -------------------# 03 user services endpoints start here #-------------------------

export const createAdminUser = (formData: object) => {
  return api.post("/admin-management/create-new-admin", formData);
};

export const updateAdminUser = (formData: object) => {
  return api.post("/admin-management/update-admin-details", formData);
};

export const changeAdminPassword = (formData: object) => {
  return api.post("/admin-management/update-admin-password", formData);
};

export const getAllAdminUserList = (formData: object, page: number, rowsPerPage: number) => {
  const params = {
    page: page,
    size: rowsPerPage,
  };
  return api.post("/admin-management/get-all-admin-details", formData, {
    params: params,
  });
};

export const createOwnerUser = (formData: object) => {
  return api.post("/owner-management/create-new-owner", formData);
};

export const getAllOwnerList = (formData: object, page: number, rowsPerPage: number) => {
  const params = {
    page: page,
    size: rowsPerPage,
  };
  return api.post("/owner-management/get-all-owners", formData, {
    params: params,
  });
};

export const getAllOwnerListWithoutPagination = (formData: object) => {
  return api.post("/owner-management/get-all-owners-without-pagination", formData);
};

export const updateOwnerUser = (formData: object) => {
  return api.post("/owner-management/update-owner-details", formData);
};

export const getParentDetailsById = (formData: object) => {
  return api.post("/owner-management/get-owner-details-by-id", formData);
};

export const getParentChannelAndMaskList = (formData: object) => {
  return api.post("/owner-management/get-owner-masks-and-channels", formData);
};

export const updateParnetAssignChannels = (formData: object) => {
  return api.post("/owner-management/update-owner-assign-channel-list", formData);
};

export const changeOwnerPassword = (formData: object) => {
  return api.post("/owner-management/update-owner-password", formData);
};

export const createChildUser = (formData: object) => {
  return api.post("/child-user-management/create-new-child-user", formData);
};

export const getAllApiUserListWithoutPagination = (formData: object) => {
  return api.post("/child-user-management/get-all-api-users-without-pagination", formData);
};

export const getAllChildUserList = (formData: object, page: number, rowsPerPage: number) => {
  const params = {
    page: page,
    size: rowsPerPage,
  };
  return api.post("/child-user-management/get-all-child-users", formData, {
    params: params,
  });
};

export const getAssignMasks = (formData: object) => {
  return api.post("/child-user-management/get-api-user-mask-list", formData);
};

export const getAssignChannels = (formData: object) => {
  return api.post("/child-user-management/get-api-user-assign-channel-list", formData);
};

export const updateChildUser = (formData: object) => {
  return api.post("/child-user-management/update-child-user-details", formData);
};

export const updateApiUserMaskList = (formData: object) => {
  return api.post("/child-user-management/update-api-user-mask-list", formData);
};

export const updateApiUserChannelList = (formData: object) => {
  return api.post("/child-user-management/update-api-user-assign-channel-list", formData);
};

export const changeChildPassword = (formData: object) => {
  return api.post("/child-user-management/update-child-user-password", formData);
};

export const resetPassword = (formData: object) => {
  return api.post("/login/password-reset", formData);
};

export const getAllApproverList = (formData: object, page: number, rowsPerPage: number) => {
  const params = {
    page: page,
    size: rowsPerPage,
  };
  return api.post("/approver-management/get-all-appovers", formData, {
    params: params,
  });
};

export const createApprover = (formData: object) => {
  return api.post("/approver-management/create-new-approver", formData);
};

export const updateApprover = (formData: object) => {
  return api.post("/approver-management/update-approver-details", formData);
};

export const changeApproverPassword = (formData: object) => {
  return api.post("/approver-management/update-approver-password", formData);
};

export const getApproverListWithoutPagination = (formData: object) => {
  return api.post("/approver-management/get-all-approvers-without-pagination", formData);
};

export const getSelfRegUsers = (formData: object, page: number, rowsPerPage: number) => {
  return api.post("/self-registered-users-management/get-registered-user-details", formData, { params: { page: page, size: rowsPerPage } });
};

export const maskAsViewed = (formData: object) => {
  return api.post("/self-registered-users-management/mark-as-viewed", formData);
};

// -------------------# 04 report services endpoints start here #-------------------------

export const getApiCampaignReportList = (formData: object, page: number, rowsPerPage: number) => {
  let params = {
    page: page,
    size: rowsPerPage,
  };

  return api.post("/reports-management/get-all-api-bulk-campaign-details", formData, {
    params: params,
  });
};

export const getSingelCampaignReportList = (formData: object, page: number, rowsPerPage: number) => {
  let params = {
    page: page,
    size: rowsPerPage,
  };

  return api.post("/reports-management/get-all-single-api-campaign-details", formData, { params: params });
};

export const getFlashCampaignReportList = (formData: object, page: number, rowsPerPage: number) => {
  let params = {
    page: page,
    size: rowsPerPage,
  };

  return api.post("/reports-management/get-all-flash-campaign-details", formData, { params: params });
};

export const getBulkCampaignReportList = (formData: object, page: number, rowsPerPage: number) => {
  let params = {
    page: page,
    size: rowsPerPage,
  };

  return api.post("/reports-management/get-all-bulk-campaign-details", formData, { params: params });
};

export const getCampaignNumberList = (formData: object, page: number, rowsPerPage: number) => {
  let params = {
    page: page,
    size: rowsPerPage,
  };
  return api.post("/reports-management/get-api-bulk-campaign-number-details-by-campaign-id", formData, { params: params });
};

export const getFlashCampaignNumberList = (formData: object, page: number, rowsPerPage: number) => {
  let params = {
    page: page,
    size: rowsPerPage,
  };
  return api.post("/reports-management/get-flash-campaign-number-details-by-campaign-id", formData, { params: params });
};

export const getBulkSmsCampaignNumberList = (formData: object, page: number, rowsPerPage: number) => {
  let params = {
    page: page,
    size: rowsPerPage,
  };
  return api.post("/reports-management/get-bulk-campaign-number-details-by-campaign-id", formData, { params: params });
};

export const getBulkCampaignNumberList = (formData: object, page: number, rowsPerPage: number) => {
  let params = {
    page: page,
    size: rowsPerPage,
  };
  return api.post("/reports-management/get-bulk-campaign-number-details-by-campaign-id", formData, { params: params });
};

export const getPendingCampaignReportList = (formData: object, page: number, rowsPerPage: number) => {
  let params = {
    page: page,
    size: rowsPerPage,
  };
  return api.post("/reports-management/get-all-pending-campaign-details", formData, { params: params });
};

export const getCampaignDetailsByCampaignId = (formData: object) => {
  return api.post("/reports-management/get-campaign-and-opt-out-details-by-id", formData);
};

export const approveSecondApproverCampaings = (formData: object) => {
  return api.post("/campaign-approve-management/approve-campaign-second-level", formData);
};

export const approveFirstApproverCampaings = (formData: object) => {
  return api.post("/campaign-approve-management/approve-campaign-first-level", formData);
};

export const getAllFirstApproverCampaings = (page: number, rowsPerPage: number) => {
  return api.post("/campaign-approve-management/get-all-first-level-approve-pending-campaigns", null, { params: { pase: page, size: rowsPerPage } });
};

export const getAllSecondApproverCampaings = (page: number, rowsPerPage: number) => {
  return api.post("/campaign-approve-management/get-all-second-level-approve-pending-campaigns", null, { params: { pase: page, size: rowsPerPage } });
};

// -------------------# 05 dashboard services endpoints start here #-------------------------

export const getDashboardDeliveredNumberCount = (formData: object) => {
  return api.post("/dashboard-management/get-total-delivered-number-count-up-to-date", formData);
};

export const getDashboardTotalRevenue = (formData: object) => {
  return api.post("/dashboard-management/get-total-revenue-up-to-date", formData);
};

export const getDashboardParentBaseRevenue = (formData: object, page: number, rowsPerPage: number) => {
  let postData = formData;
  let params = {
    page: page,
    size: rowsPerPage,
  };

  return api.post("/dashboard-management/get-top-parent-users-revenue-based", postData, { params: params });
};

export const getDashboardParentDeliveryNumberCount = (formData: object, page: number, rowsPerPage: number) => {
  let postData = formData;
  let params = {
    page: page,
    size: rowsPerPage,
  };

  return api.post("/dashboard-management/get-revenue-and-total-number-count-monthly-for-user", postData, { params: params });
};

// -------------------# 06 configuration services endpoints start here #-------------------------

export const getOptOutMessage = () => {
  return api.post("/opt-out-management/get-opt-out-details");
};

export const updateOptOutMessage = (formData: object) => {
  let postData = formData;

  return api.post("/opt-out-management/update-opt-out-details", postData);
};

export const getTaxDetails = () => {
  return api.post("/tax-management/get-tax-details");
};

export const updateTaxDetails = (formData: object) => {
  let postData = formData;

  return api.post("/tax-management/update-tax-details", postData);
};

export const getBlackoutTime = (formData: object) => {
  let postData = formData;

  return api.post("/blackout-time-management/get-blackout-time-details", postData);
};

export const updateBlackoutTime = (formData: object) => {
  let postData = formData;

  return api.post("/blackout-time-management/update-blackout-time-details", postData);
};

// -------------------# 07 mask services endpoints start here #-------------------------

export const getMaskList = (formData: object, page: number, rowsPerPage: number) => {
  let params = {
    page: page,
    size: rowsPerPage,
  };

  return api.post("/mask-management/get-all-masks-list", formData, {
    params: params,
  });
};

export const getAllMaskList = (formData: object, page: number, rowsPerPage: number) => {
  let params = {
    page: page,
    size: rowsPerPage,
  };

  return api.post("/mask-management/get-all-mask-list", formData, {
    params: params,
  });
};

export const getMaskListByOwnerId = (formData: object, page: number, rowsPerPage: number) => {
  let params = {
    page: page,
    size: rowsPerPage,
  };

  return api.post("/mask-management/get-mask-by-owner-id", formData, {
    params: params,
  });
};

export const getOwnerMaskListWithoutPagination = () => {
  return api.post("/mask-management/get-owner-mask-list-without-pagination");
};

export const addNewMask = (formData: object) => {
  let postData = formData;

  return api.post("/mask-management/create-new-mask-for-parent-user", postData);
};

export const changeMaskStatus = (formData: object) => {
  let postData = formData;

  return api.post("/mask-management/change-parent-mask-status", postData);
};

// -------------------# 08 campaign services endpoints start here #-------------------------

export const createAdminFlashCampaign = (formData: FormData) => {
  let postData = formData;

  return api.post("/campaign/admin/send-flash-sms", postData);
};

export const updateCampaignDetails = (formData: FormData) => {
  let postData = formData;

  return api.post("campaign/parent/all/update-campaign", postData);
};

export const createAdminBulkCampaign = (formData: FormData) => {
  let postData = formData;

  return api.post("/campaign/admin/send-bulk-sms", postData);
};

export const createParentFlashCampaign = (formData: FormData) => {
  let postData = formData;

  return api.post("/campaign/parent/send-flash-sms", postData);
};

export const changeCampaignStatus = (formData: object) => {
  let postData = formData;

  return api.post("/campaign-status-change-management/change-campaign-status-by-campaign-id", postData);
};

export const getCampaignCreatedNumberList = (formData: FormData) => {
  let postData = formData;

  return api.post("/campaign-approve-management/get-campaign-created-contact-lists", postData);
};

export const createParentBulkCampaign = (formData: FormData) => {
  let postData = formData;

  return api.post("/campaign/parent/send-bulk-sms", postData);
};

export const createAdminContactListFlashCampaign = (formData: object) => {
  let postData = formData;

  return api.post("/campaign/admin/contact-lists/send-flash-sms", postData);
};

export const createAdminContactListBulkCampaign = (formData: object) => {
  let postData = formData;

  return api.post("/campaign/admin/contact-lists/send-bulk-sms", postData);
};

export const createAdminPersonalizedCampaign = (formData: FormData) => {
  let postData = formData;

  return api.post("/campaign/admin/personalized/send-bulk-sms", postData);
};

export const createParentContactListFlashCampaign = (formData: object) => {
  let postData = formData;

  return api.post("/campaign/parent/contact-lists/send-flash-sms", postData);
};

export const createParentContactListBulkCampaign = (formData: object) => {
  let postData = formData;

  return api.post("/campaign/parent/contact-lists/send-bulk-sms", postData);
};

export const createParentPersonalizedCampaign = (formData: FormData) => {
  let postData = formData;

  return api.post("/campaign/parent/personalized/send-bulk-sms", postData);
};

// -------------------# 09 contact list services endpoints start here #-------------------------

export const getContactList = (formData: object, page: number, rowsPerPage: number) => {
  return api.post("/contact-list-view-management/get-all-contact-lists", formData, {
    params: {
      page: page,
      size: rowsPerPage,
    },
  });
};

export const createContactList = (formData: FormData) => {
  return api.post("/contact-list/create", formData);
};
